<template>
  <h1 id="variable-container">
    <span v-for="(character, index) in splitText" :key="index">{{ character }}</span>
  </h1>
</template>

<script>
export default {
  name: "LoginVariableFont",
  props: {
    text: String,
  },

  computed: {
    splitText() {
      return this.text.split("");
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/variables";

#variable-container {
  span {
    display: inline-block;

    transition-property: transform;
    transition-duration: 0.1s;
    transition-timing-function: ease-in-out;

    &:hover {
      transform: scaleX(1.3) translateX(-5px);
    }
  }
}
h1 {
  font-size: 4em;
  margin: 20px;
}
</style>
